module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.duration >= 0 && _vm.endToNow >= 0) ? _c('p', {
    staticClass: "help-block"
  }, [(_vm.startToNow >= 0) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('marker.activation_time_help', {
    at: _vm.start.locale(_vm.locale).fromNow(),
    duration: _vm.readableDuration(_vm.duration, _vm.locale)
  })) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('marker.activation_immediate_help', {
    duration: _vm.readableDuration(_vm.endToNow, _vm.locale)
  })) + "\n    ")])]) : (_vm.duration < 0) ? _c('p', {
    staticClass: "help-block error"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('marker.invalid_duration')) + "\n  ")]) : (_vm.endToNow < 0) ? _c('p', {
    staticClass: "help-block error"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('marker.invalid_end_time')) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47aa6db2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/DurationHelper.vue
// module id = 1038
// module chunks = 1